var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDoubleTop = function SvgArrowDoubleTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.5 3.224 4.362 7.362l.943.943L8.5 5.11l3.195 3.195.943-.943zm0 3.767-4.138 4.138.943.943L8.5 8.876l3.195 3.196.943-.943z"
  })));
};
export default SvgArrowDoubleTop;